import logo from './assets/space1.png';
import './App.css';
import Main from './pages/main';
import Head from '../src/pages/header';


function App() {
  return (
    
    <div className="App">
    
      <header className="App-header"><br/>
      <Head/>
         <br/>
         <img src={logo} className="App-logo" alt="logo" />  
         

        <Main/>
      
      </header>
     
    </div>
  );
}

export default App;
